import { createAsyncThunk } from '@reduxjs/toolkit';
import * as inboxApi from '../../api/inboxapi';

import * as historyApi from '../../api/history';

export const getInboxList = createAsyncThunk('getInboxList', async (data) => {
    const res = await inboxApi.getInboxList({ data: data });
    return res.data;
});

export const addInboxComposeMessageLog = createAsyncThunk('addInboxComposeMessageLog', async (data) => {
    const res = await inboxApi.addInboxComposeMessageLog({ data: data });
    return res.data;
});

export const getMessageLogHistory = createAsyncThunk('getMessageLogHistory', async (data) => {
    const res = await inboxApi.getMessageLogHistory({ data: data });
    return res.data;
});

export const getRefreshMessageLogHistory = createAsyncThunk('getRefreshMessageLogHistory', async (data) => {
    const res = await inboxApi.getMessageLogHistory({ data: data });
    return res.data;
});

export const getAppointmentListGroupByLocation = createAsyncThunk('getAppointmentListListGroupByLocation', async (data) => {
    const res = await inboxApi.getAppointmentListList({ data: data });
    return res.data;
});


export const profileCommunicationCheckbox = createAsyncThunk('profileCommunicationCheckbox', async (data) => {
    const res = await historyApi.profileCommunicationCheckbox({ data: data });
    return res.data;
});